import { render, staticRenderFns } from "./CampaignAdditionals.vue?vue&type=template&id=32cf45d2&"
import script from "./CampaignAdditionals.vue?vue&type=script&lang=js&"
export * from "./CampaignAdditionals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports